import { ComponentStyleConfig } from '@chakra-ui/react';
import { COARSE_POINTER_FIELD_FONT } from '../../constants/media';

// On touch screens every Chakra field is held at 16px, even when a size or a
// fontSize prop asks for smaller text, so iOS doesn't zoom on focus.
export const Input: ComponentStyleConfig = {
	baseStyle: {
		field: COARSE_POINTER_FIELD_FONT,
	},
};

export const NumberInput: ComponentStyleConfig = {
	baseStyle: {
		field: COARSE_POINTER_FIELD_FONT,
	},
};

export const Select: ComponentStyleConfig = {
	baseStyle: {
		field: COARSE_POINTER_FIELD_FONT,
	},
};

export const Textarea: ComponentStyleConfig = {
	baseStyle: COARSE_POINTER_FIELD_FONT,
};

export const PinInput: ComponentStyleConfig = {
	baseStyle: COARSE_POINTER_FIELD_FONT,
};
